<script setup lang="ts">
import { type BaseButtonProps } from '@/components/buttons'
import BaseButton from '@/components/buttons/BaseButton.vue'

const props = defineProps<BaseButtonProps>()
const emit = defineEmits<{click: [Event]}>()
const click = ($event: Event) => emit('click', $event)
</script>

<template>
  <BaseButton
    v-bind="props"
    severity="informational"
    variant="warn"
    @click="click"
  >
    <slot name="default">Submit</slot>
  </BaseButton>
</template>

<style scoped></style>
